"use client";

import moment from "moment";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";

import AdvertisementBlock from "@/components/blocks/AdvertisementBlock";
import { useTheme } from "@/components/providers/ThemeProvider";
import { PageAdBlocksTypes } from "@/types/page";
import Link from "next/link";

export default function EpaperHeader({
  adMain,
  adSingle,
}: {
  adMain?: PageAdBlocksTypes;
  adSingle?: PageAdBlocksTypes;
}) {
  const [isClient, setIsClient] = useState(false);

  const { darkMode } = useTheme();
  const pathName = usePathname();
  const isDetailPage = pathName.split("/").length === 5;
  const ad = isDetailPage ? adSingle : adMain;

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setIsClient(true);
  }, []);

  return (
    <div className="border-b">
      {ad && (ad?.adImage || ad?.adCode) && (
        <div className="w-full h-[90px] md:h-[100px] lg:h-[120px] ">
          <div className="container mx-auto px-4 h-full flex items-center justify-center">
            <AdvertisementBlock
              advertisementData={ad}
              block={{ adType: "horizontal", blockType: "", id: ad?.id }}
            />
          </div>
        </div>
      )}
      <div className={" " + (isDetailPage ? " px-5 " : " container ")}>
        <div className="flex items-center justify-between py-3">
          <div className="flex items-end gap-3">
            <Link href="/">
              <img
                className="w-[240px] h-[45px] lg:w-[280px] lg:h-[50px] object-cover"
                alt="Deshabhimani"
                src={!darkMode ? "/deshabhimanilogo.svg" : "/deshabhimanilogo-white.svg"}
              />
            </Link>
            <span className="block bg-[#FFD325] rounded-full font-[600] text-[12px] py-[1px] px-3">
              E-PAPER
            </span>
          </div>
          {pathName === "/epaper" && isClient && (
            <div className="w-[170px] hidden md:block dark:text-white">
              <div className="text-[50px] float-left font-[300] mr-2 leading-[50px]">
                {moment(new Date()).format("DD")}
              </div>
              <span className="block mt-[9px] text-[13px]">
                {moment(new Date()).format("MMMM")}
              </span>
              <span className="block text-[13px]">{moment(new Date()).format("dddd")}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
